import { getDtrumInstance } from './utils/getDtrumInstance';
export var dtRum = getDtrumInstance();
//# sourceMappingURL=dtRum.js.map